import React, { Fragment, useState } from "react";

const LiveDiscussionSearchInput = () => {
  const [noValue, setValue] = useState("");
  return (
    <Fragment>
      <section className="live-hero">
        <div className="job-search-container">
          <form action="/liveonime/discussions" className="form-flex-alt">
            <div className="label-input">
              <label htmlFor="discussions" className="labels green">
                Search<i className="fas fa-search green mx-5"></i>
              </label>
              <div className="input-drop-down">
                <div className="search-input-hidden">
                  <input
                    className="search-input-style"
                    type="text"
                    name="mentors"
                    placeholder="Enter Innovator Name, Discussion Type or Keywords"
                    onChange={(e) => setValue(e.target.value)}
                  />
                  <button
                    className="search-button background-green"
                    type="submit"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
                {noValue && (
                  <div className="hero-search-results">
                    <div className="profile-drop-container">
                      <i className="far fa-user-circle fa-2x drop-down-icon green"></i>
                      <p className="drop-down-text">Innovator</p>
                    </div>
                    <div className="profile-drop-container">
                      <i className="fas fa-video fa-lg drop-down-icon green"></i>
                      <p className="drop-down-text">
                        Discussion Type or Keywords
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </section>
    </Fragment>
  );
};

export default LiveDiscussionSearchInput;
